import React from 'react'
import _ from 'lodash'
import type { Listing, Property } from '@adc/sdk/types'
import ListingCard from '../listingCard'
import { ListingCardLinkProps } from '../listingCard/cardParts'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)
interface ListingListProps {
  listings: Listing[]
  toggleSavedProperty?: (
    property: Property,
    trackingContext: any
  ) => Promise<void>
  // Optional controlled saved-state resolver. When provided, the card heart is
  // driven by this instead of listing.primary_property.is_currently_saved — so
  // consumers backed by a useSavedProperties collection don't have to merge
  // saved-state into their listing objects.
  getIsSaved?: (listing: Listing) => boolean
  onListingCardClick?: ListingCardLinkProps['onClick']
  featureFlags?: object
}

const ListingList: React.FC<ListingListProps> = ({
  listings,
  toggleSavedProperty,
  getIsSaved,
  onListingCardClick,
  featureFlags,
}) => {
  const showResults = listings && listings.length > 0
  return (
    <div data-elm-id='listing_list_container'>
      {showResults && (
        <div data-elm-id='listing_list_properties' className={cx('cards-wrap')}>
          {listings.map((listing, i) => (
            <div key={listing.listing_id} className={cx('card', 'u-mb-3')}>
              <ListingCard
                elmId={`property_card_${i}`}
                listing={listing}
                isSaved={getIsSaved ? getIsSaved(listing) : undefined}
                onSaveToggle={toggleSavedProperty}
                showSave={!_.isNil(toggleSavedProperty)}
                linkProps={{
                  href: listing.listing_page_path,
                  onClick: onListingCardClick,
                }}
                featureFlags={featureFlags}
              />
            </div>
          ))}
        </div>
      )}
      {!showResults && (
        <p
          data-elm-id='listing_list_no_results'
          className={cx('u-mt-2 u-mb-2')}
        >
          No listings available.
        </p>
      )}
    </div>
  )
}
export default ListingList
